import type { PillProps } from "@validereinc/common-components";
import type { WorkflowTemplateType } from "@validereinc/domain";

export const WorkflowTemplateStatusToPillVariantMapping: Record<
  WorkflowTemplateType["status"],
  PillProps["variant"]
> = {
  active: "success",
  draft: "info",
  archive: "default",
};
